export default __webpack_public_path__ + "static/media/net-config.03d0f328.yaml";